// https://www.notion.so/dahubio/Status-f17f11eaa9b44e4aa2b2de0b5464d969

/**
 * ListingSyncStatus
 * Uberall diffuser sync status
 */
export enum ListingSyncStatus {
  /**
   * Impossible de vérifier la synchronisation des données sur le diffuser
   */
  NOT_FOUND = "NOT_FOUND",

  /**
   * Toutes les données sont à jour
   * La localisation est synchronisée, vérifiée et mise à jour
   */
  IN_SYNC = "IN_SYNC",

  /**
   * Statut de mise à jour configuré manuellement sur nova
   * Mise à jour terminée mais indiquer que certains champs ne le sont pas tout à fait encore
   * -
   */
  SYNC_IN_PROGRESS = "SYNC_IN_PROGRESS",
}

/**
 * ListingConnectStatus
 * Uberall diffuser connect status
 */
export enum ListingConnectStatus {
  NOT_CONNECTED = "NOT_CONNECTED",
  CONNECTED = "CONNECTED",
}

/**
 * ListingGoogleStatus
 * Our google connect status
 */
export enum ListingGoogleStatus {
  /**
   * Non connecté
   * L'utilisateur doit se connecter
   * connectStatus = NOT_CONNECTED && claimStatus = UNKNOWN
   */
  NOT_CONNECTED = "NOT_CONNECTED",

  /**
   * Pas de liste trouvée
   * -
   * connectStatus = CONNECTED && claimStatus = UNKNOWN
   */
  NOT_FOUND = "NOT_FOUND",

  /**
   * Liste vérifiée
   * Tout va bien, aucune action à effectuer
   * connectStatus = CONNECTED && claimStatus = CLAIMED_BY_US
   */
  VERIFIED = "VERIFIED",

  /**
   * Liste vérifiée mais non connecté
   * L'utilisateur doit demander les droits à l'administrateur ou se connecter avec un autre compte
   * connectStatus = CONNECTED && claimStatus = CLAIMED_BY_OTHERS
   */
  NOT_CONNECTED_VERIFIED = "NOT_CONNECTED_VERIFIED",

  /**
   * Combinaison autre, erreur inconnue
   * -
   */
  ERROR = "ERROR",
}

/**
 * ListingFacebookStatus
 * Our facebook connect status
 */
export enum ListingFacebookStatus {
  /**
   * Non connecté
   * L'utilisateur doit se connecter
   * connectStatus = NOT_CONNECTED && claimStatus != CLAIMED_BY_US
   */
  NOT_CONNECTED = "NOT_CONNECTED",

  /**
   * Pas de liste trouvée
   * -
   * connectStatus = CONNECTED && claimStatus != CLAIMED_BY_US
   */
  NOT_FOUND = "NOT_FOUND",

  /**
   * Liste trouvée
   * -
   * connectStatus = CONNECTED && claimStatus = CLAIMED_BY_US
   */
  FOUNDED = "FOUNDED",

  /**
   * Combinaison autre, erreur inconnue
   * -
   */
  ERROR = "ERROR",
}

/**
 * ListingStatus
 * Our diffuser status
 */
export enum ListingStatus {
  /**
   * En attente du lancement de la première synchro, aucune synchro n'a jamais été lancée
   * (listingStatus !== erreur) && currentEstablishment.last_sync === null
   */
  WAIT_FOR_SYNC = "WAIT_FOR_SYNC",

  /**
   * Synchronisé : tout est à jour
   * syncStatus = IN_SYNC
   */
  SYNCHRONIZED = "SYNCHRONIZED",

  /**
   * Non synchronisé : pas encore connecté ou manque d'infos (horaires, catégorie)
   * connectStatus = NOT_CONNECTED
   */
  ERROR_NOT_CONNECTED = "ERROR_NOT_CONNECTED",

  /**
   * Combinaison autre, erreur inconnue
   * -
   */
  ERROR = "ERROR",

  /**
   * Attente de validation de connexion diffuseur local OT
   * -
   */
  PENDING_CONNECTION = "PENDING_CONNECTION",

  /**
   * Statut de mise à jour configuré manuellement sur nova
   * Mise à jour terminée mais indiquer que certains champs ne le sont pas tout à fait encore
   * -
   */
  SYNC_IN_PROGRESS = "SYNC_IN_PROGRESS",

  /**
   * Statut de mise à jour configuré manuellement sur nova
   * A surveiller, pas d'affichage spécifique en front (jamais renvoyé par l'api normalement)
   * -
   */
  PROCESSING = "PROCESSING",
}
